import { Tag, Text } from 'ui/components';
import { TagVariants } from 'ui/components/primitives/Tag/Tag.enums';

import { getFormattedMessage, messages } from './getFormattedMessage';

const ProductTag = ({ tag }: { tag?: string }) => {
  if (tag && messages[`catalog.product.badge.${tag}`]) {
    const ariaLabel = `Este produto está em ${messages[`catalog.product.badge.${tag}`]}`;
    return (
      <Tag variant={tag === TagVariants.PROMOTION ? TagVariants.PROMOTION : 'lightDark1'}>
        <Text variant="auxiliar-mini">
          <span tabIndex={0} aria-label={ariaLabel}>
            {getFormattedMessage(`catalog.product.badge.${tag}`)}
          </span>
        </Text>
      </Tag>
    );
  }

  return <></>;
};

export default ProductTag;
